// extracted by mini-css-extract-plugin
export var closeButton = "_1c-3";
export var header = "_1c-0";
export var link = "_1c-1";
export var retryButton = "_1c-2";